import { NavLink, useLocation } from 'react-router-dom'

import styles from './Tabs.module.scss'

const Tabs = ({ children, className }) => {
  return <div className={[styles.tabs, className].join(' ')}>{children}</div>
}

const Tab = ({ children, to, disabled, exact = false, style = {} }) => {
  const location = useLocation()

  const isActive = location.pathname + location.search === to

  return (
    <NavLink
      exact={exact}
      isActive={exact ? () => isActive : undefined}
      className={styles.tab}
      activeClassName={styles.active}
      to={to}
      style={disabled ? { opacity: 0.5, pointerEvents: 'none', ...style } : style}
    >
      {children}
    </NavLink>
  )
}

Tab.Parent = Tabs
export default Tab
